import {
    madnes_audio_allow_multiple,
    madnes_audio_continue,
    madnes_audio_fade_in,
    madnes_audio_fade_out,
    madnes_audio_fade_to, madnes_audio_get_volume,
    madnes_audio_is_paused,
    madnes_audio_is_playing,
    madnes_audio_levels,
    madnes_audio_loop,
    madnes_audio_onstop,
    madnes_audio_pause,
    madnes_audio_play, madnes_audio_set_volume,
    madnes_audio_stop, madnes_set_audio_volume
} from "../../../framework/src/engine/madnes/madnes_audio";

/**
 * @constructor
 * @param {string} name
 * @returns {MadnesAudio}
 */
export function MadnesAudio(name) {
    this.name = name;

    if(typeof madnes_audio_levels[name] === "undefined") {
        madnes_audio_levels[name] = 1;
    }

    this._initVolume = madnes_audio_levels[name];
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.play = function() {
    madnes_audio_play(this.name);
    return this;
};

/**
 * @param {number=} fromVolume
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.loop = function(fromVolume) {
    madnes_audio_loop(this.name, fromVolume);
    return this;
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.stop = function() {
    madnes_audio_stop(this.name);
    return this;
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.pause = function() {
    madnes_audio_pause(this.name);
    return this;
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.continue = function() {
    madnes_audio_continue(this.name);
    return this;
};

/** @returns {boolean|undefined} */
MadnesAudio.prototype.isPaused = function() {
    return madnes_audio_is_paused(this.name);
};

MadnesAudio.prototype.onStop = function(func) {
    madnes_audio_onstop(this.name, func);
};

/**
 * @param {number} duration
 * @param {number} volume
 * @param {Function=} callback
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.fadeTo = function(duration, volume, callback) {
    madnes_audio_fade_to(this.name, volume, duration, callback);
    return this;
};

/**
 * @param {number} duration
 * @param {Function=} callback
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.fadeToInit = function(duration, callback) {
    madnes_audio_fade_to(this.name, this._initVolume, duration, callback);
    return this;
};

/**
 * @param {number} duration
 * @param {number} perc
 * @param {Function=} callback
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.fadeToPerc = function(duration, perc, callback) {
    madnes_audio_fade_to(this.name, this._initVolume * perc, duration, callback);
    return this;
};

/**
 * @param {number} duration
 * @param {boolean=} stop
 * @param {Function=} callback
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.fadeOut = function(duration, stop, callback) {
    madnes_audio_fade_out(this.name, duration, stop, callback);
    return this;
};

/**
 * @param {number} duration
 * @param {Function=} callback
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.fadeIn = function(duration, callback) {
    madnes_audio_fade_in(this.name, duration, callback);
    return this;
};

/**
 * @returns {boolean}
 */
MadnesAudio.prototype.isPlaying = function() {
    return madnes_audio_is_playing(this.name);
};

/**
 * @param {number} perc
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.changeVolume = function(perc) {
    madnes_audio_levels[this.name] = this._initVolume * perc;
    madnes_audio_set_volume(this.name, this._initVolume * perc);
    return this;
};

/**
 * @returns {number}
 */
MadnesAudio.prototype.getInitVolume = function() {
    return this._initVolume;
};

/**
 * @returns {number}
 */
MadnesAudio.prototype.getVolume = function() {
    return madnes_audio_get_volume(this.name);
};

/**
 * @param {number} vol
 * @returns {MadnesAudio}
 */
MadnesAudio.prototype.setVolume = function(vol) {
    madnes_audio_set_volume(this.name, vol);
    return this;
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.reinitVolume = function() {
    madnes_audio_set_volume(this.name, this._initVolume);
    return this;
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.setInitVolume = function(vol) {
    this._initVolume = vol;
    madnes_set_audio_volume(this.name, vol);
    return this;
};

/** @returns {MadnesAudio} */
MadnesAudio.prototype.allowMultiple = function() {
    madnes_audio_allow_multiple(this.name);
    return this;
};